var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component.name,
    _vm._b(
      {
        tag: "component",
        attrs: { disabled: _vm.disabled },
        model: {
          value: _vm.internalValue,
          callback: function($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue"
        }
      },
      "component",
      _vm.component.props,
      false
    ),
    [_vm._v(_vm._s(_vm.component.text))]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3be897f5", { render: render, staticRenderFns: staticRenderFns })
  }
}